export default function (el, bindings) {
  const { value } = bindings
  const {
    scoutIcon,
    coordinatesCenter,
    coordinatesScout,
    circleColor,
    circleRadius
  } = value
  const map = {
    yMap: null,
    config: {
      options: {
        center: coordinatesCenter,
        zoom: 17,
        controls: []
      },
      el
    },
    pins: {
      stadium: null,
      scout: null,
      icons: {
        scout: {
          circleColor,
          circleRadius,
          href: scoutIcon,
          size: [24, 24],
          offset: [-12, -12],
          coordinates: coordinatesScout,
          layout: 'default#image'
        }
      }
    }
  }

  map.yMap = new ymaps.Map(map.config.el, map.config.options)

  map.pins.scout = new ymaps.Placemark(
    map.pins.icons.scout.coordinates,
    {},
    {
      iconLayout: map.pins.icons.scout.layout,
      iconImageHref: map.pins.icons.scout.href,
      iconImageSize: map.pins.icons.scout.size,
      iconImageOffset: map.pins.icons.scout.offset
    }
  )

  map.pins.megaradius = new ymaps.Circle(
    [map.pins.icons.scout.coordinates, map.pins.icons.scout.circleRadius],
    {
      balloonContent: null,
      hintContent: null
    },
    {
      draggable: false,
      fillColor: map.pins.icons.scout.circleColor,
      fillOpacity: '0.2',
      strokeWidth: 0
    }
  )

  map.yMap.behaviors.disable('scrollZoom')

  map.yMap.geoObjects
    .add(map.pins.scout)
    .add(map.pins.megaradius)
}
